import React from "react";
import { ClipboardListIcon } from "@heroicons/react/solid";

// Company logos
const citiLogo = require("../assets/images/citi.png");
const waveLogo = require("../assets/images/wave.png");
const sotiLogo = require("../assets/images/SOTI.png");
const mcmasterLogo = require("../assets/images/mcmaster.jpg");

// Resume PDF
const resumePdf = require("../assets/resume/MananSharmaResume.pdf");

const Resume = () => {
  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = resumePdf;
    link.download = "MananSharmaResume.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div
      id="Resume"
      className="lg:w-1/2 mt-20 mb-4 mx-6 sm:mx-12 lg:mr-60 lg:ml-auto text-left lg:text-justify"
    >
      <div>
        <div className="flex items-center">
          <ClipboardListIcon className="h-5 w-5 mr-4 text-yellow_vs" />
          <div className="text-[#e6f1ff] text-4xl mt-5">Resume</div>
          <div className="border-b border-b-[#e6f1ff] border-opacity-25 w-full ml-4"></div>
        </div>
      </div>
      <div className="text-[#a2aabc] text-xl mt-5">
        <button
          onClick={handleDownload}
          className="border border-lightblue_vs text-lightblue_vs mt-5 p-3 rounded hover:bg-opacity-10 hover:bg-lightblue_vs"
        >
          Download My Resume
        </button>

        {/* Education Section */}
        <div className="pt-10">
          <div className="text-yellow_vs text-2xl mb-4">Education</div>
          <div className="bg-[#1a1a1a] rounded-lg p-5">
            <div className="flex items-start gap-4">
              <img src={mcmasterLogo} alt="McMaster" className="w-12 h-12 rounded object-cover flex-shrink-0" />
              <div className="flex-1">
                <div className="text-blue_vs text-lg font-medium">McMaster University</div>
                <div className="italic text-lightblue_vs text-base">
                  Bachelor's of Software Engineering Coop
                </div>
                <div className="text-brown_vs text-sm mt-1">Sept 2021 - April 2026</div>
                <div className="mt-3">
                  <div className="text-blue_vs text-base">Relevant Courses:</div>
                  <div className="text-white_vs text-base mt-1">
                    Software Design, Concurrent System Design, Object-Oriented
                    Programming, Data Structures and Algorithms, Computer
                    Architecture, Databases
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Experience Section */}
        <div className="pt-10">
          <div className="text-yellow_vs text-2xl mb-4">Experience</div>
          <div className="space-y-6">

            {/* Wave HQ - Full-time */}
            <div className="bg-[#1a1a1a] rounded-lg p-5">
              <div className="flex items-start gap-4">
                <img src={waveLogo} alt="Wave HQ" className="w-12 h-12 rounded object-contain bg-white p-1 flex-shrink-0" />
                <div className="flex-1">
                  <div className="text-blue_vs text-lg font-medium">Software Engineer</div>
                  <div className="italic text-lightblue_vs text-base">Wave HQ · Full-time</div>
                  <div className="text-brown_vs text-sm mt-1">May 2026 - Present</div>
                  <ul className="list-disc list-outside ml-5 mt-3 space-y-2 text-base text-[#a2aabc]">
                    <li>Developing backend platform services using TypeScript, GraphQL, RPC and SQL, contributing to core infrastructure that supports scalable data access and service communication across Wave’s products.</li>
                    <li>Deployed AI-powered automations across multiple business operations, leveraging LLMs, workflow orchestration, API integrations, and agent-based systems to automate manual processes and streamline decision-making.</li>
                    <li>Building and maintaining event-driven backend workflows using Kafka, AWS services, and cloud infrastructure to support reliable asynchronous processing and platform-level scalability.</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Citi */}
            <div className="bg-[#1a1a1a] rounded-lg p-5">
              <div className="flex items-start gap-4">
                <img src={citiLogo} alt="Citi" className="w-12 h-12 rounded object-contain bg-white p-1 flex-shrink-0" />
                <div className="flex-1">
                  <div className="text-blue_vs text-lg font-medium">Software Engineer Intern</div>
                  <div className="italic text-lightblue_vs text-base">Citi Bank - Missisauga, Canada</div>
                  <div className="text-brown_vs text-sm mt-1">May 2025 - August 2025</div>
                  <ul className="list-disc list-outside ml-5 mt-3 space-y-2 text-base text-[#a2aabc]">
                    <li>Developed Angular features for YARDS, a reference data platform supporting trading desks, improving workflows.</li>
                    <li>Implemented high-volume Java/Spring Boot APIs integrated with Oracle and STAN databases to validate and update reference datasets, reducing manual Swagger requests and saving the production team 10+ hours/week.</li>
                    <li>Deployed services to production via OpenShift and Harness; delivered incrementally in Agile sprints with code reviews and CI/CD pipelines.</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Wave */}
            <div className="bg-[#1a1a1a] rounded-lg p-5">
              <div className="flex items-start gap-4">
                <img src={waveLogo} alt="Wave" className="w-12 h-12 rounded object-contain bg-white p-1 flex-shrink-0" />
                <div className="flex-1">
                  <div className="text-blue_vs text-lg font-medium">Software Engineer Intern</div>
                  <div className="italic text-lightblue_vs text-base">Wave - Toronto, Canada</div>
                  <div className="text-brown_vs text-sm mt-1">Jan 2025 - April 2025</div>
                  <ul className="list-disc list-outside ml-5 mt-3 space-y-2 text-base text-[#a2aabc]">
                    <li>Developed and unit-tested new React/TypeScript UI flows and Ruby-on-Rails APIs, integrating them into our microservice architecture and packaging each service in its own Docker image for local and staging environments.</li>
                    <li>Revamped end-to-end testing setup using Playwright, CircleCI, and Docker, reducing test runtime by 45% and minimizing flaky tests for faster, more reliable deployments.</li>
                    <li>Built a logger package to report errors to Sentry and Datadog, integrated into 4+ projects, improving observability.</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* SOTI */}
            <div className="bg-[#1a1a1a] rounded-lg p-5">
              <div className="flex items-start gap-4">
                <img src={sotiLogo} alt="SOTI" className="w-12 h-12 rounded object-contain bg-white p-1 flex-shrink-0" />
                <div className="flex-1">
                  <div className="text-blue_vs text-lg font-medium">Software Developer Intern</div>
                  <div className="italic text-lightblue_vs text-base">SOTI - Missisauge, Canada</div>
                  <div className="text-brown_vs text-sm mt-1">May 2024 - December 2024</div>
                  <ul className="list-disc list-outside ml-5 mt-3 space-y-2 text-base text-[#a2aabc]">
                    <li>Contributed to the development and optimization of user interfaces and frontend features using Angular, HTML, CSS, and TypeScript, enhancing the functionality and user experience of SOTI Internet of Things (IoT) platform.</li>
                    <li>Participated in Agile development processes, including daily stand-ups and three-week sprints, utilizing Jira for issue tracking and Git for version control.</li>
                    <li>Implemented continuous integration and deployment (CI/CD) pipelines with Jenkins, maintaining a stable and reliable codebase through automated testing and regular updates.</li>
                    <li>Collaborated with QA teams to develop and execute test plans, leveraging testing tools to ensure the quality and reliability of the software.</li>
                    <li>Collaborated with a team of developers, gaining exposure to a wide range of tasks from fixing bugs to developing new features.</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* McMaster Sumobot */}
            <div className="bg-[#1a1a1a] rounded-lg p-5">
              <div className="flex items-start gap-4">
                <img src={mcmasterLogo} alt="McMaster" className="w-12 h-12 rounded object-cover flex-shrink-0" />
                <div className="flex-1">
                  <div className="text-blue_vs text-lg font-medium">Web Developer</div>
                  <div className="italic text-lightblue_vs text-base">McMaster Sumobot - Hamilton, Canada</div>
                  <div className="text-brown_vs text-sm mt-1">Sept 2023 - April 2024</div>
                  <ul className="list-disc list-outside ml-5 mt-3 space-y-2 text-base text-[#a2aabc]">
                    <li>Managed and maintained a highly dynamic website, employing a versatile tech stack including Vue.js, HTML, Javascript, CSS, and Node.js. Presented a seamless user experience.</li>
                    <li>Collaborated with a diverse team to ensure timely updates based on client feedback. Streamlined development processes with Git, Yarn, and Node.js.</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Programming Tutor */}
            <div className="bg-[#1a1a1a] rounded-lg p-5">
              <div className="flex items-start gap-4">
                <div className="flex-1">
                  <div className="text-blue_vs text-lg font-medium">Programming Tutor</div>
                  <div className="italic text-lightblue_vs text-base">Self-Employed - Brampton, Canada</div>
                  <div className="text-brown_vs text-sm mt-1">May 2023 - Sept 2023</div>
                  <ul className="list-disc list-outside ml-5 mt-3 space-y-2 text-base text-[#a2aabc]">
                    <li>Guided students in mastering Python fundamentals, including key programming concepts and essential algorithm/data structure principles, through interactive methods and hands-on exercises.</li>
                    <li>Designed numerous thoughtful lessons, fostering problem-solving skills and imparting Python programming expertise.</li>
                    <li>Mentored students to apply core knowledge to real-world projects, equipping them with practical abilities.</li>
                  </ul>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default Resume;
